<template>
    <page
        :id="state_identifier"
        :title="title"
        :status="page_status"
        :waiting="waiting"
        @statused="statused"
    >
        <template v-slot:title><span></span></template>

        <ul
            v-if="prospective"
            class="uk-subnav uk-subnav-line uk-margin-top"
        >
            <li :class="{'uk-active': !addl_services}"><a href @click.prevent="addl_services = false">Prospective Projects</a></li>
            <li :class="{'uk-active': addl_services}"><a href @click.prevent="addl_services = true">Additional Services</a></li>
        </ul>

        <additional-services
            v-if="prospective && addl_services"
            class="uk-margin-top"
        />
        <prospective-projects
            v-else-if="prospective"
            class="uk-margin-top"
        />
        <active-projects
            v-else
            class="uk-margin-large-top"
        />
    </page>
</template>

<script type="text/javascript">
import is_page from "../../mixins/IsPage"

import ProspectiveProjects from "./List/ProspectiveProjects"
import ActiveProjects from "./List/ActiveProjects"
import AdditionalServices from "./List/AdditionalServices"

export default {
    mixins: [is_page],
    components: {
        ProspectiveProjects,
        ActiveProjects,
        AdditionalServices
    },
    computed: {
        title () {
            if(this.prospective && this.addl_services) return "Additional Services"
            if(this.prospective) return "Prospective Projects"
            return "Projects"
        },
        state_identifier () {
            if(this.prospective && this.addl_services) return "service_request.list"
            if(this.prospective) return "prospective_project.list"
            return "project.list"
        }
    },
    props: {
        prospective: {
            type: Boolean,
            required: true
        }
    },
    data () {
        return {
            addl_services: false
        }
    }
}
</script>
